import PageNav from "../components/PageNav";
import { pageData } from "../content/Network";
import PageSection from "../components/PageSection";
import PageIntro from "../components/PageIntro";

const Network = () => {
  return (
    <>
      <PageIntro
        title="Network"
        subtitle="Where our partners help us operate and extend trusted financial access."
        compactBottom
        contentWidthClass="max-w-[1400px]"
        bottomPadding="pb-4 md:pb-6"
      >
        <PageNav data={pageData} isFlush />
      </PageIntro>
      <PageSection data={pageData} compactTop />
    </>
  );
};

export default Network;
